import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlay } from 'react-icons/fa';
import PanicButton from '../../../UI/PanicButton';

const DriverActionRow = () => {
    const navigate = useNavigate();

    return (
        <div className="dv-actions-row mb-3">
            <button className="bry-btn bry-btn-primary flex-fill" onClick={() => navigate('/day-register')}>
                <FaPlay size={14} />
                <span>Iniciar Jornada</span>
            </button>
            <div className="flex-fill">
                <PanicButton />
            </div>
        </div>
    );
};

export default DriverActionRow;
